import { BareActionContext } from 'vuex-typex'
import { ConvoState } from '../state'
import { RootState } from '../..'
import { ConvoService } from '../../../service/ConvoService'
import convoStore from '../convo-store'
import convoUtils from './convo-utils'
import fetchLikes from './fetch-likes'
import { IConvo } from '../../../model/convo'

export default async function unlikeConvo(context: BareActionContext<ConvoState, RootState>, convo: IConvo)
{
  convoUtils.convoService.unlike(convo).then((result: any) => {
    fetchLikes(context, convo)
  })

  return
}